import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_TRACKING } from '../actions';
import { flattenBookingsToJobs } from '../api/DataHandlers';

const loadTrackingEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_TRACKING).mergeMap(action =>
        Observable.from(api.fetchTracking(action.payload))
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            .map(response => toAction(response))
            .catch(() =>
                Observable.of(
                    actions.trackingFailure('Problem loading tracking'),
                ),
            ),
    );

const toAction = response => {
    if (response) {
        return actions.trackingSuccess(flattenBookingsToJobs(response.data));
    }
    return actions.trackingFailure('Problem loading tracking');
};

export default loadTrackingEpic;
